import React from "react";
import State789CommandCenterHomePage from "./State789CommandCenterHomePage";

export default function State789DashboardPage() {
  return <State789CommandCenterHomePage />;
}
